import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-delete-account-dialog',
  templateUrl: './delete-account-dialog.component.html',
  styleUrls: ['./delete-account-dialog.component.css']
})
export class DeleteAccountDialogComponent implements OnInit {
   loading: boolean;
  api_error: any;
  api_success: string;
  accountId: any;
  accountType: any;
  accountDetails: any;
  branchId: any;
  isBranch = false;
  corpId: any;
  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: number,
    private accountService: AccountService
    ) { }

  ngOnInit() {
    this.accountId = this.data['id'];
    this.accountType = this.data['accountType'];
    this.accountDetails = this.data['details'];
    if (this.accountType === 'BRANCH' || this.accountType === 'BRANCH_SP') {
      console.log(this.accountDetails);
      console.log(this.accountDetails.branch.id + this.accountDetails.branch.corpId);
      this.isBranch = true;
      this.branchId = this.accountDetails.branch.id;
      this.corpId = this.accountDetails.branch.corpId;
    }

  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onDeleteConfirm() {
    if (this.isBranch) {
      if (this.accountType === 'BRANCH') {
        this.deleteBranch();
      } else if (this.accountType === 'BRANCH_SP') {
        this.deleteBranchSP();
      }

    } else {
      this.deleteAccount();
    }
  }

  deleteAccount() {
    this.loading = true;
    const filter = 'id-eq=' + this.data['id'] + '&' + 'accountType-eq=' + this.accountType;
    this.accountService.deleteAccount(filter)
    .subscribe(
      data => {
        this.loading = false;
        this.api_success = 'Account deleted Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
       this.loading = false;
      this.api_error = error.error;
      }
    );

}

deleteBranch() {

    this.loading = true;
    const filter = 'branchId-eq=' + this.branchId + '&' + 'accountType-eq=' + this.accountType + '&corpId-eq=' + this.corpId ;
    this.accountService.deleteBranch(filter)
    .subscribe(
      data => {
        this.loading = false;
        this.api_success = 'Branch deletion is successfully initated, you will receive an email after deletion';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
       this.loading = false;
      this.api_error = error.error;
      }
    );


}
deleteBranchSP() {
  this.loading = true;
  // tslint:disable-next-line:max-line-length
  const filter = 'id-eq=' + this.data['id'] + '&branchId-eq=' + this.branchId + '&' + 'accountType-eq=' + this.accountType + '&corpId-eq=' + this.corpId ;
  this.accountService.deleteBranch(filter)
  .subscribe(
    data => {
      this.loading = false;
      this.api_success = 'Branch_sp deletion is successfully initated, you will receive an email after deletion';
      setTimeout(() => {
        this.dialogRef.close('reloadlist');
        }, 2000);
      },
   (error) => {
     this.loading = false;
    this.api_error = error.error;
    }
  );
}
}
